'use strict';

var stringify = require('./stringify').default;
var parse = require('./parse').default;
var formats = require('./formats').default;

export default {
    formats: formats,
    parse: parse,
    stringify: stringify
};



// WEBPACK FOOTER //
// ./src/utils/qs/index.js